import errorImage from "@assets:error.png";
import { Box, Button, Typography } from "@mui/material";
import { MdKeyboardArrowLeft } from "react-icons/md";

export const ErrorPage = () => {
  return (
    <Box
      sx={{
        background: (theme) => theme.palette.background.default,
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        paddingTop: "7rem",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
        }}
      >
        <Box
          component="img"
          src={errorImage}
          alt=""
          width={200}
          height={200}
          sx={{
            mx: "auto",
          }}
        />
        <Typography
          variant="h1"
          sx={{
            marginTop: "1rem",
            fontSize: "34px",
            letterSpacing: "-0.025em",
            color: "gray.900",
          }}
        >
          Oops, something's gone wrong!
        </Typography>
        <Typography
          variant="h6"
          sx={{
            margin: "1.5rem",
            color: "gray.600",
          }}
        >
          Not to worry, you can either go back to the previous page or head
          straight to our homepage.
        </Typography>
        <Box
          sx={{
            marginTop: "2.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            columnGap: "1.5rem",
          }}
        >
          <Button
            variant="contained"
            onClick={() => window.location.assign(window.location.origin)}
            sx={{
              fontWeight: "600",
            }}
            startIcon={<MdKeyboardArrowLeft />}
          >
            Go back home
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
